export default "/.netlify/functions"

